<template>
  <app-page-title :color="'sun'">
    <template #pageTitleLeft>
      <h1>Payment History</h1>
    </template>
    <template #pageTitleRight>
      <async-button
        type="button"
        class="_mls btn --sm"
        @clicked="exportToCSV"
        :disabled='exporting'
        :executing="exporting"
      >
        Export
      </async-button>
      <router-link class="_mls btn --sm" :to="{name: 'billing-overview'}">Billing Home</router-link>
    </template>
  </app-page-title>
</template>

<script>
  import AppPageTitle from '@sections/PageTitle'
  import { mapGetters } from 'vuex'
  import AsyncButton from '@molecules/AsyncButton'
  import { now } from '@/utils'

  export default {
    components: {
      AsyncButton,
      AppPageTitle
    },
    props: ['filteredInvoicePaymentHistory'],
    data () {
      return {
        exporting: false
      }
    },
    computed: {
      ...mapGetters(['paymentsAvailable', 'invoicePaymentHistory'])
    },
    methods: {
      exportToCSV () {
        this.exporting = true
        let csvContent = []
        let csvHelpers = [
          { text: 'Payment Date', value: 'paidDate' },
          { text: 'Invoice Type', value: 'invoiceTypeDescription' },
          { text: 'Group', value: 'group', visible: true },
          { text: 'Subgroup', value: 'subGroup', visible: true },
          { text: 'Invoice Date', value: 'displayInvoiceDate' },
          { text: 'Invoice No.', value: 'invoiceNumber' },
          { text: 'Invoice Amount', value: 'displayInvoiceAmount' },
          { text: 'Payment Type', value: 'paymentTypeDescription' },
          { text: 'Payment Method', value: 'paymentMethod' },
          { text: 'Payment Cycle', value: 'paymentCycleDescription' },
          { text: 'Transaction Amount', value: 'displayPaidAmount' },
          { text: 'User Id', value: 'paidUser' }
        ]

        const showAllData = this.filteredInvoicePaymentHistory && this.filteredInvoicePaymentHistory.length > 0 ? this.filteredInvoicePaymentHistory[0].showAllPaymentData : false;

        if (showAllData) {
          csvHelpers.push({ text: 'Invoice Status', value: 'paymentStatus' })
        }

        let firstRow = csvHelpers.map(helper => helper.text)
        csvContent.push(firstRow)

        this.filteredInvoicePaymentHistory
          .sort((a, b) => {
            return new Date(b.paidDate) - new Date(a.paidDate)
          })
          .map(paymentHistory => {
            return csvHelpers.map(helper => `\"${paymentHistory[helper.value] ? paymentHistory[helper.value] : ''}\"`)
          })
          .forEach(row => csvContent.push(row))

        let csvString = csvContent
          .map(line => line.join(','))
          .join('\r\n')

        let a = document.createElement('a')
        let csvData = new Blob([csvString], { encoding: 'UTF-8', type: 'text/csv;charset=UTF-8' })
        a.href = URL.createObjectURL(csvData)
        a.download = `eyemed_payment_history_${now()}.csv`
        document.body.appendChild(a)
        a.click()

        this.exporting = false
      }
    }
  }
</script>
